export default "Pilotierte RCT zu Yoga bei Brustkrebs-assoziiertem Lymphödem – Yoga als Selbstmanagement-Baustein neben lymphologischer Versorgung."